import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import { Clock } from 'lucide-react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
// Fix for default marker icon in react-leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png'
});
export const LocationSection: React.FC = () => {
  // Coordinates for Restaurante Perla Negra - XFC7+669, Zacapa
  const position: [number, number] = [14.9706, -89.5363];
  return <section id="ubicacion" className="py-16 px-4 bg-wood-texture bg-cover bg-center relative" data-id="element-77">
      <div className="absolute inset-0 bg-pirate-black opacity-80" data-id="element-78"></div>
      <div className="container mx-auto relative z-10" data-id="element-79">
        <h2 className="font-pirata text-3xl md:text-4xl text-center mb-10" data-id="element-80">
          Ubicación y Horarios
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-6xl mx-auto" data-id="element-81">
          <div className="bg-pirate-black bg-opacity-70 p-6 rounded-lg border border-pirate-red" data-id="element-82">
            <div className="flex items-center mb-6" data-id="element-83">
              <Clock size={24} className="text-pirate-red mr-3" data-id="element-84" />
              <h3 className="font-pirata text-2xl" data-id="element-85">Horarios de navegación</h3>
            </div>
            <ul className="space-y-4 text-lg" data-id="element-86">
              <li className="flex justify-between" data-id="element-87">
                <span data-id="element-88">Martes a Domingo:</span>
                <span className="font-semibold" data-id="element-89">12:00 PM – 10:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-90">
                <span data-id="element-91">Lunes:</span>
                <span className="font-semibold" data-id="element-92">Cerrado</span>
              </li>
              <li className="text-sm italic mt-2 text-gray-300" data-id="element-93">
                (día de mantenimiento del barco ⚓)
              </li>
            </ul>
            <div className="mt-8" data-id="element-94">
              <h4 className="font-pirata text-xl mb-3" data-id="element-95">Dirección:</h4>
              <p className="text-lg" data-id="element-96">Zacapa, Zacapa, Guatemala</p>
              <p className="mt-2 text-pirate-red" data-id="element-97">Tel: 5628-4598</p>
            </div>
          </div>
          <div className="h-[400px] rounded-lg overflow-hidden border-2 border-pirate-red" data-id="element-98">
            <MapContainer center={position} zoom={15} style={{
            height: '100%',
            width: '100%'
          }} zoomControl={false} data-id="element-99">
              <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-100" />
              <Marker position={position} data-id="element-101">
                <Popup data-id="element-102">
                  Restaurante Perla Negra <br data-id="element-103" />
                  ¡Te esperamos a bordo!
                </Popup>
              </Marker>
            </MapContainer>
          </div>
        </div>
      </div>
    </section>;
};